var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multilang-text-field',{attrs:{"placeholder":_vm.$t('categories.categoryName')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }